import { ImplementorTemplateParams } from "components/stories/video-studio/utils/creatomate/setCustomTemplate";
import deleteElement from "components/stories/video-studio/utils/creatomate/deleteElement";
import syncMediaElements from "components/stories/video-studio/utils/creatomate/syncMediaElements";
import { ELEMENT_NAMES } from "components/stories/video-studio/utils/constants";
import { cacheAssetIfNeeded, calculateVideoDuration } from "../../utils/utils";
import findElementByName from "../../utils/findElementByName";

const brandedTemplateForEmployeeTalkingVideoPremiseTemplate = async ({
  preview,
  organization,
  mediaElements,
  defaultVideoProperties,
  story
}: ImplementorTemplateParams) => {
  cacheAssetIfNeeded(preview, story);

  const json = preview.getSource();
  const elements = json?.elements;

  const promptElement = findElementByName(elements, ELEMENT_NAMES.PROMPT);
  const nameAndTitleElement = findElementByName(elements, ELEMENT_NAMES.NAME_AND_TITLE);
  const companyLogoElement = findElementByName(elements, ELEMENT_NAMES.COMPANY_LOGO);
  const storyVideoElement = findElementByName(elements, ELEMENT_NAMES.STORY);
  const bottomLeftImageElement = findElementByName(elements, ELEMENT_NAMES.BOTTOM_LEFT_IMAGE);
  const quoteImageElement = findElementByName(elements, ELEMENT_NAMES.QUOTE_IMAGE);
  const coolGradientElement = findElementByName(elements, ELEMENT_NAMES.COOL_GRADIENT);
  const topRightImageElement = findElementByName(elements, ELEMENT_NAMES.TOP_RIGHT_IMAGE);

  await syncMediaElements(preview, mediaElements, {
    ...defaultVideoProperties,
    track: storyVideoElement?.track,
    x: storyVideoElement?.x,
    width: storyVideoElement?.width,
    height: storyVideoElement?.height,
    border_radius: storyVideoElement?.border_radius
  }, 0);
  await deleteElement(preview, storyVideoElement?.id);
  const videoDuration = calculateVideoDuration(mediaElements);
  await preview.applyModifications({
    [`${promptElement?.id}.text`]: story?.question?.question,
    [`${promptElement?.id}.duration`]: videoDuration,
    [`${nameAndTitleElement?.id}.text`]: `${story?.creator.name}\n${story?.creator.title}`,
    [`${nameAndTitleElement?.id}.duration`]: videoDuration,
    [`${companyLogoElement?.id}.source`]: organization.logo.originalUrl,
    [`${companyLogoElement?.id}.duration`]: videoDuration,
    [`${bottomLeftImageElement?.id}.duration`]: videoDuration,
    [`${quoteImageElement?.id}.duration`]: videoDuration,
    [`${coolGradientElement?.id}.duration`]: videoDuration,
    [`${topRightImageElement?.id}.duration`]: videoDuration,
    duration: videoDuration
  });
};

export default brandedTemplateForEmployeeTalkingVideoPremiseTemplate;
